export default __webpack_public_path__ + "static/media/invest_navicon.b490e854.svg";